<template>
  <v-dialog v-model="showDialog" width="1400px">
    <v-card>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close"> Fechar </v-btn>
      </v-card-actions>

      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab>Buscar contato</v-tab>

        <v-tab>Novo contato</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card>
            <v-card-text>
           
              <v-row class="ma-4">
                
                <v-text-field
                  label="Busca"
                  v-model = "nameSearch"
                  @blur="filterContacts"
                ></v-text-field>
                <v-spacer></v-spacer>
              </v-row>
            </v-card-text>

            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th style="width: 300px" class="text-left">Código</th>
                      <th class="text-left">Descrição</th>

                      <th class="text-right">Adicionar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in itemsSearch"
                      v-bind:key="item.id"
                    >
                      <td>{{ item.name }}</td>
                      <td>{{ item.email }}</td>

                      <td class="text-right">
                        <v-btn class="primary" @click="selContact(index)"
                          >+</v-btn
                        >
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="3" sm="12">
                  <v-select
                    class="mt-5"
                    v-model="newContact.typeId"
                    :items="typeOptions"
                    label="Tipo de contato"
                    item-text="text"
                    item-value="value"
                    dense
                  >
                  </v-select>
                </v-col>

                <v-col cols="12" md="4" sm="12">
                  <v-text-field label="Nome" v-model="newContact.name">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="4" sm="12">
                  <v-text-field label="Email" v-model="newContact.email">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Fone"
                    hide-details="auto"
                    v-model="newContact.phone"
                    v-mask="
                      newContact.phone
                        ? newContact.phone.length <= 13
                          ? '(##)####-####'
                          : '(##)#####-####'
                        : ''
                    "
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" v-if="newContact.typeId == 1">
                  <v-text-field
                    label="CNPJ"
                    hide-details="auto"
                    v-model="newContact.cnpj"
                    v-mask="'##.###.###/####-##'"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" v-if="newContact.typeId == 1">
                  <v-text-field
                    label="I.E."
                    hide-details="auto"
                    v-model="newContact.cnpj"
                    v-mask="'###.###.###.###'"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4" v-if="newContact.typeId == 2">
                  <v-text-field
                    label="CPF"
                    hide-details="auto"
                    v-model="newContact.cpf"
                    v-mask="'###.###.###-##'"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <autocomplete-city
                    @changed="changedCity"
                    :preSearch="newContact.cityName"
                  ></autocomplete-city>
                </v-col>

                <v-col cols="12" md="9">
                  <v-text-field
                    label="Endereço"
                    hide-details="auto"
                    v-model="newContact.streetAddress"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="CEP"
                    hide-details="auto"
                    v-mask="'##.###-###'"
                    @blur="updatedZipCode"
                    v-model="newContact.zipCode"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="1">
                  <v-text-field
                    label="Número"
                    hide-details="auto"
                    v-model="newContact.streetAddressNumber"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    label="Complemento"
                    hide-details="auto"
                    v-model="newContact.streetAddressNumber2"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    label="Bairro"
                    hide-details="auto"
                    v-model="newContact.neighborhood"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-text>
              <v-row>
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="saveContact">Salvar</v-btn>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import Contact from "../../../../libraries/classes/Contact";
import hebelApi from "../../../../libraries/hebel/hebelApi";
import AutocompleteCity from "../../component/AutocompleteCity.vue";

export default {
  components: { AutocompleteCity },
  name: "modal-contact",
  props: ["showDialog", "section", "deviceTypes"],
  data() {
    return {
      tab: null,
      newContact: {},
      typeOptions: [
        { value: 1, text: "Empresa" },
        { value: 2, text: "Pessoa" },
      ],
      contacts:[],
      itemsSearch:[],
      nameSearch:"",
    };

  },

  watch: {
    searchCity(val) {
      val && val !== this.select && this.querySelections(val);
    },
  },
  computed: {},
  created() {
    // this.preSearch = ""
  },
  async mounted() {
    this.newContact = new Contact();
    this.contacts = await hebelApi.contacts.getAll();
    this.itemsSearch = this.contacts;
    //this.searchCity = ""
    //this.preSearch = "Campinas - SP";
  },

  methods: {
    filterContacts() {
      // alert("changedType")
      this.itemsSearch = this.contacts.filter(
        (element) => element.name.toUpperCase().includes(this.nameSearch.toUpperCase())
      );
    },
    selContact(index) {
     // alert(index);
      this.$emit("selContact", this.itemsSearch[index]);

    },
    async updatedZipCode() {
      // alert("test>:" + this.site.zipCode);

      var info = await this.$globalFunctions.searchZipCode(
        this.newContact.zipCode
      );
      //var info = await this.$globalFunctions.searchZipCode("13.026-340");

      this.search = info.cityName;
      this.newContact.cityName = info.cityName;

      //alert(JSON.stringify(info));
      this.newContact.streetAddress = info.streetAddress;
      this.newContact.neighborhood = info.neighborhood;
      //this.site.
    },

    async saveContact() {
      var c = await hebelApi.contacts.upsert(this.newContact);
      this.newContact.id = c.id;
      this.$emit("selContact", this.newContact);
    //  this.showDialog = false;
    },
    changedCity(cityName) {
      this.newContact.cityName = cityName;
    },

    close() {
      // alert("close")
      this.$emit("close");
    },
  },
};
</script>


<style scoped>
</style>